module.exports = __webpack_public_path__ + "img/conny-stage5-hungry.055db306.png";